import "./UserCabinet.scss";
import { useEffect } from "react";
import { useAppDispatch } from "store";
import {
  getClientProfileInfo,
  getClientRequests,
} from "../../store/reducers/cabinet";
import Header from "components/Header/Header";
import TabsPanel from "components/TabsPanel/TabsPanel";
import CabinerCopyrightSection from "components/CabinetCopyrightSection/CabinetCopyrightSection";

const UserCabinet = () => {
  const dispatch = useAppDispatch();

  const logout = () => {
    const storageKeys = ["Authorization", "clientId", "type", "email"];
    storageKeys.forEach((key) => {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    });

    window.location.href = "/?form=sign";
  };

  const logoutIcon = () => {
    const storageKeys = ["Authorization", "clientId", "type", "email"];
    storageKeys.forEach((key) => {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    });
  }

  useEffect(() => {
    dispatch(getClientProfileInfo());
    dispatch(getClientRequests());
  }, [dispatch]);

  return (
    <div className="user-cabinet">
      <Header isCabinet={true} logout={logoutIcon}/>
      <TabsPanel />
      <div className="logout-container">
        <div className="logout-btn" onClick={() => logout()}>
          Log out
        </div>
      </div>
      <CabinerCopyrightSection />
    </div>
  );
};

export default UserCabinet;
